import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AdvancedSearch: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AdvancedSearch" */ './AdvancedSearch.tsx'))
			.AdvancedSearch,
});
